export default __webpack_public_path__ + "static/media/Slide48.1171dc28.PNG";